document.addEventListener('DOMContentLoaded', function () {
  function initVideoWithImages(section) {
    // ── Video play handler ────────────────────────────────────────────────────
    section
      .querySelectorAll('.video-thumbnail__image')
      .forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          this.style.display = 'none'
          const embed = this.parentNode.querySelector('.video-thumbnail__embed')
          if (embed) embed.style.display = 'block'
        })
      })

    // ── Slider setup ──────────────────────────────────────────────────────────
    const sliderContainer = section.querySelector('.video-with-images__slider')
    if (!sliderContainer) return

    const slider = sliderContainer.querySelector('.slider-track')
    const columns = parseInt(sliderContainer.dataset.columns || '2', 10)

    function getSlideWidth() {
      const firstSlide = slider.querySelector('.slider-item')
      return firstSlide ? firstSlide.getBoundingClientRect().width + 5 : 160 // +gap
    }

    function getScrollStep() {
      const isMobile = window.innerWidth <= 1024
      return isMobile ? getSlideWidth() : getSlideWidth() * columns
    }

    sliderContainer.querySelector('.next')?.addEventListener('click', () => {
      slider.scrollBy({ left: getScrollStep(), behavior: 'smooth' })
    })

    sliderContainer.querySelector('.prev')?.addEventListener('click', () => {
      slider.scrollBy({ left: -getScrollStep(), behavior: 'smooth' })
    })

    // ── Move section video into slider on mobile (only when video-wrapper exists) ──
    const sliderTrack = sliderContainer.querySelector('.slider-track')
    if (window.innerWidth <= 768 && sliderTrack && !sliderTrack.dataset.videoInserted) {
      const videoWrapper = section.querySelector('.video-wrapper')

      if (videoWrapper) {
        sliderTrack.dataset.videoInserted = 'true'

        const videoSlide = document.createElement('div')
        videoSlide.classList.add('slider-item')
        videoSlide.innerHTML = videoWrapper.innerHTML

        if (sliderTrack.children.length > 0) {
          sliderTrack.insertBefore(videoSlide, sliderTrack.children[1])
        } else {
          sliderTrack.appendChild(videoSlide)
        }

        const newThumb = videoSlide.querySelector('.video-thumbnail__image')
        if (newThumb) {
          newThumb.addEventListener('click', function () {
            this.style.display = 'none'
            const embed = this.parentNode.querySelector('.video-thumbnail__embed')
            if (embed) embed.style.display = 'block'
          })
        }
      }
    }
  }

  // Initialise every instance of the section on the page independently
  document.querySelectorAll('[data-section-id]').forEach(function (section) {
    if (section.classList.contains('video-with-images')) {
      initVideoWithImages(section)
    }
  })
})
